import React, { useState, useContext ,useEffect} from "react"
import styled from "styled-components"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import { JourneyContext } from "../context/journeyContext"
import Loader1 from "../../interceptors/loader-interceptor"
import { withPrefix } from "gatsby"
import { awsImageUrl } from "../../services/apiservice"
import { DataLayerIntegration } from "../services/helperFunctions"
import { getSourceFromChannel, isEquitasChannel } from "../services/helperFunctions"
import { successToastr } from "../../services/error-handler"
// import { window, document } from "browser-monads";

SwiperCore.use([Navigation])

export default function Submission(props) {
  const [key, setKey] = useState("first")
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const handleClick = val => {
    var formControlKey
    if(val === "first"){
      formControlKey = "first"
    }else if(val === "second"){
      formControlKey = "second"
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, formControlKey, journeyState)
    setKey(val)
  }
  const [b64Pdf,setB64Pdf] = useState();
  const submissionUrl = "https://www.canarahsbclife.com/index.html";

  const onItemClick = async()=>{
    if (isEquitasChannel(journeyState?.channel)) {
      successToastr("Pdf Download Started...")
    }
    const fileName = journeyState.proposalFormLink;
    if(b64Pdf){
      // For Other Browsers
      const linkSource = "data:application/pdf;filename=" + encodeURIComponent(fileName) + ";base64," + b64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "downloadForm", journeyState)
    }else{
      const res = await awsImageUrl(journeyState.proposalFormLink, journeyState.applicationNo);   
      setB64Pdf(res.data);
      // For Other Browsers
      const linkSource = "data:application/pdf;filename=" + encodeURIComponent(fileName) + ";base64," + res.data
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "downloadForm", journeyState)
    }
    // console.log(res.data); 
    // const data = "jfhfkdshf"
  }
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    let urlPart  =window.location.search.toLowerCase()
    console.log(urlPart);

    if(urlPart.includes('hsbc')){
      document.body.style.backgroundColor = "#ededed";
    }
   
  }, [])

  return (
    <>
    <Loader1/>
      <style>
        {`
          @media(max-width:767px){
              #checkboxG6-error{font-size: 13px !important; bottom:-15px !important;}
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }
          span#checkboxG6-error {
              font-size: 15px;
          }
          .d-none{
              display: none;
          }   
          .br-0{
              border-radius: 0px !important;
          }
        
      `}
      </style>

      {/* body Section */}
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            {/* <!--left-side--> */}
            <div className="iselect-box-design">
              <div className="iselect-padding">
                <div className="row medical-recommender-product-structure mt-30">
                  <div className="col-md-12 medical-recommender-product-structure-left-side">
                    <div className="payment-receipt-structure-design medical-recommender-product-structure-design">
                      <div className="payment-receipt-structure-design-healine medical-recommender-product-structure-headline">
                        {" "}
                        <img src={withPrefix("/images/success-icon.png")} />
                        <h2>Congratulations!</h2>
                        <span>Your Application is submitted successfully</span>
                        <div className="line"></div>
                        <p>
                          The proposal is under review and you will receive the
                          final policy decision, along with the policy pack
                          shortly on your registered e-mail and phone number via
                          SMS. If you wish to recieve a physical copy of the
                          policy at your residential address, kindly write to us
                          at <strong>{getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"}</strong>
                        </p>
                      </div>
                      <p className="app-medical-recomended">
                        Application Number: {journeyState.applicationNo}
                      </p>
                      <div className="download-receipt-structure" style={{background: `${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}`}}> {/*var(--lumiq-card-bg)*/}
                        {" "}
                        <a
                          style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }}
                          aria-hidden="true"
                          // href={process.env.AWS_IMAGE_URL + journeyState.proposalFormLink} target="_blank"
                          onClick={onItemClick}
                        >
                          <div className="download-ap-receipt-stucture">
                            {" "}
                            <img src={withPrefix("/images/download-receipt.png")} />
                            <p><a style={{color:"white"}} 
                                target="_blank">
                              Click to
                              <br />
                              Download form
                              </a>
                            </p>
                          </div>
                        </a>{" "}
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>
                  {/* <div className="col-md-6 other-medical-plan-recommended hidden-desktop-screen">
                    <h2 className="headline1">
                      Other Plans That Might Interest You
                    </h2>

                    <div
                      className={`other-medical-plan-recommended-buy ${
                        key === "first" ? "active" : ""
                      }`}
                      aria-hidden="true"
                      onClick={e => {
                        handleClick("first")
                      }}
                    >
                      <div className="other-medical-plan-recommended-buy-float">
                        <h2>Guaranteed Savings Plan</h2>
                        <img src={withPrefix("/images/gsp-new.jpg") } style={{width: "200px"}} />{" "}
                      </div>
                      <div className="buy-btn-other text-center">
                        {" "}
                        <a href={submissionUrl}>Buy Now</a>{" "}
                      </div>
                    </div>
                    <div
                      className={`other-medical-plan-recommended-buy ${
                        key === "second" ? "active" : ""
                      }`}
                      aria-hidden="true"
                      onClick={e => {
                        handleClick("second")
                      }}
                    >
                      <div className="other-medical-plan-recommended-buy-float">
                        <h2>Health First Plan</h2>
                        <img src={withPrefix("/images/health1-new.jpg") } style={{width: "200px"}} />{" "}
                      </div>
                      <div className="buy-btn-other text-center">
                        {" "}
                        <a href={submissionUrl}>Buy Now</a>{" "}
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-md-6 other-medical-plan-recommended mobile-medical-view-hidden">
                    <h2 className="headline1">
                      Other Plans That Might Interest You
                    </h2>

                    {/* <div
                      id="other-medical-plan-recommended-buy-slider"
                      className="owl-carousel other-medical-plan-recommended-buy-slider"
                    > */}
                    {/* <Swiper navigation={true} autoplay={true} slidesPerView={1}  >
                      <SwiperSlide>
                        <div className="item">
                          <div
                            className={`other-medical-plan-recommended-buy ${
                              key === "first" ? "active" : ""
                            }`}
                            aria-hidden="true"
                            onClick={e => {
                              handleClick("first")
                            }}
                          >
                            <div className="other-medical-plan-recommended-buy-float">
                              <h2>Guaranteed Savings Plan</h2>
                              <img src={withPrefix("/images/gsp-new.jpg")} style={{width: "200px"}} />{" "}
                            </div>
                            <div className="buy-btn-other text-center">
                              {" "}
                              <a href={submissionUrl}>Buy Now</a>{" "}
                            </div>
                          </div>
                        </div>
                        </SwiperSlide>
                        <SwiperSlide>
                        <div className="item ">
                          <div
                            className={`other-medical-plan-recommended-buy ${
                              key === "second" ? "active" : ""
                            }`}
                            aria-hidden="true"
                            onClick={e => {
                              handleClick("second")
                            }}
                          >
                            <div className="other-medical-plan-recommended-buy-float">
                              <h2>Health First Plan</h2>
                              <img src={withPrefix("/images/health1-new.jpg")} style={{width: "200px"}} />{" "}
                            </div>
                            <div className="buy-btn-other text-center">
                              {" "}
                              <a href={submissionUrl}>Buy Now</a>{" "}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper> */}
                    {/* </div> */}
                  {/* </div> */}
                </div>
              </div>
            </div>

            {/* <!--left-side--> */}
          </div>
        </div>
      </div>
    </>
  )
}
